export default __webpack_public_path__ + "static/media/privacy.02b6be66.md";